import API_ENDPOINTS from '../api/endpoints';
import apiClient from '../api/apiClient';

export const postProject = async (projectData) => {
  try {
    const response = await apiClient.post(API_ENDPOINTS.PROJECTS.CREATE_PROJECT, projectData, {
      headers: {
        'Content-Type': 'multipart/form-data', // ensures images and other form data are handled
      },
    });
    return response.data;
  } catch (error) {
    console.error("Failed to post project:", error);
    console.log("Server error response:", error?.response?.data);
    throw error; // optional: rethrow for error handling in UI
  }
};

export const updateProject = async (projectId, formData) => {
  try {
    // Make the PATCH request with the formData already prepared in the component
    const response = await apiClient.patch(`${API_ENDPOINTS.PROJECTS.UPDATE_PROJECT}${projectId}/`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',  // Automatically set by the browser if you're using FormData
      }
    });

    return response.data;
  } catch (error) {
    console.error("Failed to update project:", error);
    console.log("Server error response:", error?.response?.data);
    throw error;
  }
};

export const deleteProject = async (projectId) => {
  try {
    const response = await apiClient.delete(`${API_ENDPOINTS.PROJECTS.DELETE_PROJECT}${projectId}/`);
    return response.data;
  } catch (error) {
    console.error("Failed to delete project:", error);
    console.log("Server error response:", error?.response?.data);
    throw error;
  }
};

export const getUserProjects = async () => {
  try {
    const response = await apiClient.get(API_ENDPOINTS.PROJECTS.USER_PROJECTS);
    return response.data;
  } catch (error) {
    console.error("Failed to fetch user projects:", error);
    console.log("Server error response:", error?.response?.data);
    throw error;
  }
};

export const getProjectsByProfileId = async (profile_id) => {
  try {
    const response = await apiClient.get(`${API_ENDPOINTS.PROJECTS.PUBLIC_USER_PROJECTS(profile_id)}`);
    return response.data;
  } catch (error) {
    console.error("Failed to fetch public user projects:", error);
    console.log("Server error response:", error?.response?.data);
    throw error;
  }
};

export const getProjectById = async (id) => {
  try {
    const response = await apiClient.get(API_ENDPOINTS.PROJECTS.USER_PROJECT(id));
    return response.data;
  } catch (error) {
    console.error(`Failed to fetch project with id ${id}:`, error);
    console.log("Server error response:", error?.response?.data);
    throw error;
  }
};

export const getAllProjects = async () => {
  try {
    const response = await apiClient.get(API_ENDPOINTS.PROJECTS.ALL_PROJECTS);
    return response.data;
  } catch (error) {
    console.error("Failed to fetch all projects:", error);
    console.log("Server error response:", error?.response?.data);
    throw error;
  }
};